import { apiReducer } from '../service/api.reducer';
import { homeModel } from '../../models/core/home.model';

const DEFAULT_STATE = {
    [homeModel.MODEL_NAME]: homeModel.create()
};

export default ((state = DEFAULT_STATE, action) => {
    return apiReducer(state, action);
});


// WEBPACK FOOTER //
// ./~/pluton-core/lib/reducers/core/home.model.reducer.js